import React, { useMemo } from 'react'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles({
  container: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    overflow: 'hidden',
    pointerEvents: 'none',
    zIndex: 0
  },
  star: {
    position: 'absolute',
    backgroundColor: '#fff',
    borderRadius: '50%',
    opacity: 0,
    animation: '$twinkle var(--duration) ease-in-out infinite var(--delay)'
  },
  '@keyframes twinkle': {
    '0%, 100%': {
      opacity: 0,
      transform: 'scale(0.5)'
    },
    '50%': {
      opacity: 0.8,
      transform: 'scale(1.2)',
      boxShadow: '0 0 8px rgba(255, 255, 255, 0.8), 0 0 15px rgba(255, 255, 255, 0.4)'
    }
  }
})

const TwinklingStars = ({ count = 50 }) => {
  const classes = useStyles()

  const stars = useMemo(() => {
    return Array.from({ length: count }).map((_, i) => ({
      id: i,
      size: Math.random() * 2 + 0.5,
      top: Math.random() * 100,
      left: Math.random() * 100,
      duration: Math.random() * 3 + 2,
      delay: Math.random() * 5
    }))
  }, [count])

  return (
    <div className={classes.container}>
      {stars.map(star => (
        <div
          key={star.id}
          className={classes.star}
          style={{
            width: `${star.size}px`,
            height: `${star.size}px`,
            top: `${star.top}%`,
            left: `${star.left}%`,
            '--duration': `${star.duration}s`,
            '--delay': `${star.delay}s`
          }}
        />
      ))}
    </div>
  )
}

export default TwinklingStars
